import React, { Component, Fragment } from 'react';
import classnames from 'classnames';

import SearchFilter from '../../../components/search-filter';
import camelToDisplayText from '../../../utils/camelToDisplayText';

import textMapping from '../../../utils/textMapping';
import styles from './styles.module.css';

const toggleListValue = (list, value) =>
  list.includes(value) ? list.filter(item => item !== value) : [value, ...list];

export default class SearchControls extends Component {
  render() {
    const {
      filters,
      filterValues,
      updateFilters,
      mobileFiltersOpen
    } = this.props;
    return (
      <Fragment>
        <div
          className={classnames(styles.filters, {
            [styles.trayOpen]: mobileFiltersOpen
          })}
        >
          <div className={styles.header}>
            <h2>Filters</h2>
            <button onClick={this.props.toggleMobileFiltersOpen}>Close</button>
          </div>
          <div>
            {Object.keys(filters).map(filterName => (
              <SearchFilter
                key={filterName}
                title={camelToDisplayText(filterName)}
                amountSelected={filterValues[filterName].length}
                clearAll={() => updateFilters(filterName, [])}
                filters={filters[filterName]
                  .reduce((list, current) => {
                    if (current.includes(',')) {
                      const values = current
                        .split(',')
                        .map(value => value.trim());

                      let newList = list;
                      values.forEach(value => {
                        if (!list.includes(value)) {
                          newList = list.concat(value);
                        }
                      });

                      return newList;
                    } else {
                      return list.concat(current);
                    }
                  }, [])
                  .map(filterValue => ({
                    // Text transform if needed
                    text: textMapping(filterName, filterValue),

                    // Logic to show selected or not
                    value: filterValues[filterName].includes(filterValue),

                    // On change for individual selection
                    onChange: () =>
                      updateFilters(
                        filterName,
                        toggleListValue(filterValues[filterName], filterValue)
                      )
                  }))}
              />
            ))}
          </div>
        </div>
        <div
          className={classnames(styles.exitPanel, {
            [styles.open]: mobileFiltersOpen
          })}
          onClick={this.props.toggleMobileFiltersOpen}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/glass/search-controls/index.js